import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsCustomerServiceManagementVoiceRoute: InvariantJiraRoute = {
	name: 'project-settings-customer-service-management-voice',
	path: '/jira/customer-service-management/projects/:projectKey/settings/voice',
	exact: true,
};
